import { render, staticRenderFns } from "./FeaturedGames.vue?vue&type=template&id=13efa02b&scoped=true&"
import script from "./FeaturedGames.vue?vue&type=script&lang=js&"
export * from "./FeaturedGames.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13efa02b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VImg})
